import { Injectable } from '@angular/core';
import { PLAN_PRODUCTS } from '@domain/constants/app-variables';

import { Cargochief } from '@service/cargochief/cargochief.service';
import { AddOnSubscription } from '@state/session';
import { IS_NOT_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class AddOnSubscriptionService {
	constructor(private cargochief: Cargochief) {}

	get ASSIGN_CARRIERS(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.ASSIGN_CARRIERS);
	}

	get BOOKING_ASSISTANT(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.BOOKING_ASSISTANT);
	}

	get BOOKING_ASSISTANT_API(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.BOOKING_ASSISTANT_API);
	}

	get BULK_MATCHING(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.BULK_MATCHING);
	}

	get C4(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.C4);
	}

	get C4_API(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.C4_API);
	}

	get CAPACITY_SEARCH(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.CAPACITY_SEARCH);
	}

	get CARRIER_DEVELOPMENT(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.CARRIER_DEVELOPMENT);
	}

	get CARRIER_PROFILES(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.CARRIER_PROFILES);
	}

	get CARRIER_RATES(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.CARRIER_RATES);
	}

	get CARRIER_RECRUITING(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.CARRIER_RECRUITING);
	}

	get CUSTOMERS(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.CUSTOMERS);
	}

	get CUSTOMIZABLE_EMAILS(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.CUSTOMIZABLE_EMAILS);
	}

	get HAZMAT(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.HAZMAT);
	}

	get INTEGRATIONS(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.INTEGRATIONS);
	}

	get MULTIPLE_USERS(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.MULTIPLE_USERS);
	}

	get PRICING(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.PRICING);
	}

	get PROJECT_CARRIERS(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.PROJECT_CARRIERS);
	}

	get RECENT_TRANSACTIONS(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.RECENT_TRANSACTIONS);
	}

	get RFP(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.RFP);
	}

	get SCORECARDS(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.SCORECARDS);
	}

	get STRONG_LANES(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.STRONG_LANES);
	}

	get TASKS(): boolean {
		return this.cargochief.isAddOnSubscriptionValid(PLAN_PRODUCTS.TASKS);
	}

	hasDFMAddOnSubscription(): boolean {
		const addOnSubscriptions: AddOnSubscription[] = this.cargochief.getActiveAddOnSubscriptions();
		let hasDFMSubscription = false;
		if (IS_NOT_NULL_OR_UNDEFINED(addOnSubscriptions)) {
			addOnSubscriptions.forEach((addOnSubscription) => {
				if (addOnSubscription.addOnProduct.name.includes('DFM')) {
					hasDFMSubscription = true;
				}
			});
		}
		return hasDFMSubscription;
	}
}
